export default {
  AirMaster: 'AirMaster',
  'dashboard.index.647741-0': '日出东方物联网数据大屏',
  'dashboard.index.647741-1': '台',
  'dashboard.index.647741-2': '年',
  'dashboard.index.647741-3': '月',
  'dashboard.index.647741-4': '日',
  'dashboard.index.647741-5': '佛山市',
  总设备数: '总设备数',
  在线设备数: '在线设备数',
  离线设备数: '离线设备数',
  未激活设备数: '未激活设备数',
  'components.bottom-left.467967-0': '安装记录',
  IMEI号码: 'IMEI号码',
  产品类型: '产品类型',
  安装时间: '安装时间',
  客户名称: '客户名称',
  安装人员: '安装人员',
  安装状态: '安装状态',
  安装位置: '安装位置',
  'components.bottom-left.467967-1': '设备统计',
  'components.bottom-left.467967-2': '已安装设备',
  'components.bottom-left.467967-3': '未安装设备',
  设备总数: '设备总数',
  'components.bottom-right.424290-0': '人员统计',
  'components.bottom-right.424290-1': '人',
  'components.bottom-right.424290-2': '家',
  设备用户总人数: '设备用户总人数',
  经销商入驻数: '经销商入驻数',
  安装工入驻数: '安装工入驻数',
  售后工程师: '售后工程师',
  'components.bottom-right.424290-3': '产品总览',
  'components.bottom-right.424290-4': '设备分布',

  'components.rightContainer.712911-0': '基本信息',
  'components.rightContainer.712911-1': '设备IMEI:',
  'components.rightContainer.712911-2': '设备sn号:',
  'components.rightContainer.712911-3': '产品类型:',
  'components.rightContainer.712911-4': '三联供',
  'components.rightContainer.712911-5': '设备机型:',
  'components.rightContainer.712911-6': '爱家2Plus/030MR1PN1A1/R',
  'components.rightContainer.712911-7': '用户姓名:',
  'components.rightContainer.712911-8': 'Demo-苏先生',
  'components.rightContainer.712911-9': '用户电话:',
  'components.rightContainer.712911-10': '经销商:',
  'components.rightContainer.712911-11': '顺德基地-Demo-经销商',
  'components.rightContainer.712911-12': '安装工:',
  'components.rightContainer.712911-13': '顺德基地-Demo-安装工',
  'components.rightContainer.712911-14': '设备位置:',
  'components.rightContainer.712911-15': '广东省佛山市顺德区杏坛镇德富路73号',
  'components.rightContainer.712911-16': '家用-采暖机',
  'components.rightContainer.712911-17': '商用机系列',
  'components.rightContainer.712911-18': '家用-热水机',
  'components.leftContainer.532259-0': '操作区',
  'components.leftContainer.532259-1': '运行模式',
  'components.leftContainer.532259-2': '更多指令',
  'components.leftContainer.532259-3': '制冷',
  'components.leftContainer.532259-4': '制热',
  'components.leftContainer.532259-5': '热水',
  'components.leftContainer.532259-6': '地暖',
  'components.leftContainer.532259-7': '标准模式',
  'components.leftContainer.532259-8': '强力模式',
  'components.leftContainer.532259-9': '静音模式',
  'components.leftContainer.532259-10': '当前温度',
  'components.middleContainer.912640-0': '水箱温度',
  'components.middleContainer.912640-1': '缓冲水箱',
  'components.middleContainer.912640-2': '水箱',
  'components.middleContainer.912640-3': '出水',
  'components.middleContainer.912640-4': '回水',
  zh: '中国',
  en: 'English',
  'components.bottom - right.424290-1': '人',
  'components.bottom - right.424290-2': '家',
  山东: '山东',
  河北: '河北',
  辽宁: '辽宁',
  河南: '河南',
  陕西: '陕西',
  甘肃: '甘肃',
  山西: '山西',
  内蒙古: '内蒙古',
  两联供: '两联供',
  三联供: '三联供',
  变频热水: '变频热水',
  商用定频: '商用定频',
  商用定频冷暖: '商用定频冷暖',
  商用定频热水: '商用定频热水',
  loading: '加载中...',
  "utils.request.469615-0": "数据正在处理，请勿重复提交",
  "utils.request.469615-1": "登录状态已过期，您可以继续留在该页面，或者重新登录",
  "utils.request.469615-2": "系统提示",
  "utils.request.469615-3": "重新登录",
  "utils.request.469615-4": "取消",
  "utils.request.469615-5": "无效的会话，或者会话已过期，请重新登录。",
  "utils.request.469615-6": "后端接口连接异常",
  "utils.request.469615-7": "系统接口请求超时",
  "utils.request.469615-8": "系统接口",
  "utils.request.469615-9": "异常",
  "utils.request.469615-10": "正在下载数据，请稍候",
  "utils.request.469615-11": "下载文件出现错误，请联系管理员！",
  "utils.request.401": "认证失败，无法访问系统资源",
  "utils.request.403": "当前操作没有权限",
  "utils.request.404": "访问资源不存在",
  "utils.request.default": "系统未知错误，请反馈给管理员",
  "bigScreen2025.250918.01": "能耗流动",
  "bigScreen2025.250918.02": "光伏",
  "bigScreen2025.250918.03": "热泵",
  "bigScreen2025.250918.04": "电网",
  "bigScreen2025.250918.05": "光伏功率占比",
  "bigScreen2025.250918.06": "光伏功率",
  "bigScreen2025.250918.07": "电网功率",
  "bigScreen2025.250918.08": "光伏能耗占比",
  "bigScreen2025.250918.09": "能耗看板",
  "bigScreen2025.250918.10": "今日消耗",
  "bigScreen2025.250918.11": "今日发电",
  "bigScreen2025.250918.12": "今日电网购电",
  "bigScreen2025.250918.13": "总消耗",
  "bigScreen2025.250918.14": "总发电",
  "bigScreen2025.250918.15": "总电网购电",
  "bigScreen2025.250918.16": "实时功率监控",
  "bigScreen2025.250918.17": "能耗统计",
  "bigScreen2025.250918.18": "能耗总计",
  "bigScreen2025.250918.19": "光伏供电",
  "bigScreen2025.250918.20": "电网供电",
  "bigScreen2025.250918.21": "光伏供电",
  "bigScreen2025.250918.22": "电网供电",
  "bigScreen2025.250918.23": "电费统计",
  "bigScreen2025.250918.24": "光伏节省电费",
  "bigScreen2025.250918.25": "电网购买电费",
  "bigScreen2025.250918.26": "设备控制",
  "bigScreen2025.250918.27": "在线",
  "bigScreen2025.250918.28": "离线",
  "bigScreen2025.250918.29": "关闭",
  "bigScreen2025.250918.30": "开启",
  "bigScreen2025.250918.31": "运行模式",
  "bigScreen2025.250918.32": "标准",
  "bigScreen2025.250918.33": "强力",
  "bigScreen2025.250918.34": "节能",
  "bigScreen2025.250918.35": "电加热",
  "bigScreen2025.250918.36": "今日",
  "bigScreen2025.250918.37": "本周",
  "bigScreen2025.250918.38": "本月",
  "bigScreen2025.250918.39": "本年",
  "bigScreen2025.250918.40": "全部",
  "bigScreen2025.250918.41": "设备 MAC",
  "bigScreen2025.250918.42": "电加热",
  "bigScreen2025.250918.43": "热",
  "bigScreen2025.250918.44": "冷",
  "bigScreen2025.250918.45": "自动",
  "bigScreen2025.250918.46": "静音",
  "bigScreen2025.250918.47": "Realinks-IOT",
  "bigScreen2025.250918.48": "Heat Pump Demo",
  "bigScreen2025.250918.49": "欢迎回来！",
  "bigScreen2025.250918.50": "请输入您的信息以登录。",
  "bigScreen2025.250918.51": "账号",
  "bigScreen2025.250918.52": "密码",
  "bigScreen2025.250918.53": "记住密码",
  "bigScreen2025.250918.54": "登录",
  "bigScreen2025.250918.55": "退出",
  "bigScreen2025.250918.56": "光伏热水器演示（2楼）",
  "bigScreen2025.250918.57": "中国 广东省 佛山",
  "bigScreen2025.250918.58": "光伏能耗占比",
  "bigScreen2025.250918.59": "累计耗电量",
  "bigScreen2025.250918.60": "累计发电量",
  "bigScreen2025.250918.61": "累计购电量",
  "bigScreen2025.250918.62": "打开项目",
  "bigScreen2025.250918.63": "请输入您的账户",
  "bigScreen2025.250918.64": "请输入您的密码",
  "bigScreen2025.250918.65": "热泵能耗",
  "bigScreen2025.250918.66": "设置定时器",
  "bigScreen2025.250918.67": "开始时间",
  "bigScreen2025.250918.68": "重复",
  "bigScreen2025.250918.69": "运行模式",
  "bigScreen2025.250918.70": "标准",
  "bigScreen2025.250918.71": "访客",
  "bigScreen2025.250918.72": "抱歉，访客模式无权发出命令。",
  "bigScreen2025.250918.73": "警告",
  "bigScreen2025.250918.74": "光伏功率",
  "bigScreen2025.250918.75": "市电功率",
  "bigScreen2025.250918.76": "热泵功率",
  "bigScreen2025.250918.77": "当前温度",
  "bigScreen2025.250918.79": "取消",
  "bigScreen2025.250918.78": "确定",
  "bigScreen2025.250918.80": "无数据",
  "bigScreen2025.250918.81": "日",
  "bigScreen2025.250918.82": "周",
  "bigScreen2025.250918.83": "月",
  "bigScreen2025.250918.84": "年",
  "bigScreen2025.250918.85": "全部",
  "bigScreen2025.250918.86": "电费统计",
  "bigScreen2025.250918.87": "系统状态",
  "bigScreen2025.250918.88": "泳池热泵",
  "bigScreen2025.250918.89": "泳池过滤阀",
  "bigScreen2025.250918.90": "循环水泵",
  "bigScreen2025.250918.91": "Filter",
  "bigScreen2025.250918.92": "开",
  "bigScreen2025.250918.93": "关",
  "bigScreen2025.250918.94": "更新时间",
  "bigScreen2025.250918.95": "泳池过滤与温度控制系统",
  "bigScreen2025.250918.96": "状态",
  "bigScreen2025.250918.97": "天",
  "bigScreen2025.250918.98": "小时",
  "bigScreen2025.250918.99": "分",
  "bigScreen2025.250918.100": "秒",
  "bigScreen2025.250918.101": "剩余过滤时间",
  "bigScreen2025.250918.102": "过滤",
  "bigScreen2025.250918.103": "剩余反冲洗时间",
  "bigScreen2025.250918.104": "反冲洗",
  "bigScreen2025.250918.105": "剩余冲洗时间",
  "bigScreen2025.250918.106": "冲洗",
  "bigScreen2025.250918.107": "排水",
  "bigScreen2025.250918.108": "再循环",
  "bigScreen2025.250918.109": "切换中",
  "bigScreen2025.250918.110": "更多",
  "bigScreen2025.250918.111": "手动",
  "bigScreen2025.250918.112": "修改序列号",
  "bigScreen2025.250918.113": "输入序列号",
  "bigScreen2025.250918.114": "更多功能",
  "bigScreen2025.250918.115": "过滤时长",
  "bigScreen2025.250918.116": "冲洗开始时间",
  "bigScreen2025.250918.117": "正洗时长",
  "bigScreen2025.250918.118": "反洗时长",
  "bigScreen2025.250918.119": "冲洗次数",
  "bigScreen2025.250918.120": "电网",
  "bigScreen2025.250918.121": "光伏",
  "bigScreen2025.250918.122": "泳池",
  "bigScreen2025.250918.123": "电表",
  "bigScreen2025.250918.124": "盐氯控制器",
  "bigScreen2025.250918.125": "泳池排水口",
  "bigScreen2025.250918.126": "盐氯发生器",
  "bigScreen2025.250918.127": "泳池热泵",
  "bigScreen2025.250918.128": "沙缸",
  "bigScreen2025.250918.129": "循环泵",
  "bigScreen2025.250918.130": "泳池过滤阀",
  "bigScreen2025.250918.131": "来自泳池",
  "bigScreen2025.250918.132": "返回泳池",
  "bigScreen2025.250918.133": "账号或者密码错误！",
  "bigScreen2025.250918.134": "光伏直驱泳池热泵运行数据分析报告",
  "bigScreen2025.250918.135": "机组类型",
  "bigScreen2025.250918.136": "机组输入功率",
  "bigScreen2025.250918.137": "机组光伏配置",
  "bigScreen2025.250918.138": "泳池水量",
  "bigScreen2025.250918.139": "日出时间",
  "bigScreen2025.250918.140": "日落时间",
  "bigScreen2025.250918.141": "光伏发电量",
  "bigScreen2025.250918.142": "电网购电量",
  "bigScreen2025.250918.143": "机组耗电量",
  "bigScreen2025.250918.144": "光伏用电量占比",
  "bigScreen2025.250918.145": "电网用电量占比",
  "bigScreen2025.250918.146": "电网购电费用",
  "bigScreen2025.250918.147": "光伏节省费用",
  "bigScreen2025.250918.148": "机组能耗统计",
  "bigScreen2025.250918.149": "机组用电量分类统计",
  "bigScreen2025.250918.150": "下载截图",
  "bigScreen2025.250918.151": "导出数据",
  "bigScreen2025.250918.152": "光伏用电量",
  "bigScreen2025.250918.153": "电网用电量",
  "bigScreen2025.250918.154": "机组用电量",
  "bigScreen2025.250918.155": "电费分类统计",
  "bigScreen2025.250918.156": "纯市电热泵等效电费对比",
  "bigScreen2025.250918.157": "光伏节省费用",
  "bigScreen2025.250918.158": "电网购电费用",
  "bigScreen2025.250918.159": "光伏费用节省比例",
  "bigScreen2025.250918.160": "机组能耗统计",
  "bigScreen2025.250918.161": "累计机组耗电量",
  "bigScreen2025.250918.162": "累计制热耗电量",
  "bigScreen2025.250918.163": "累计制冷耗电量",
  "bigScreen2025.250918.164": "累计制热时长",
  "bigScreen2025.250918.165": "累计制冷时长",
  "bigScreen2025.250918.166": "制热耗电量占比",
  "bigScreen2025.250918.167": "制冷耗电量占比",
  "bigScreen2025.250918.168": "机组平均耗电量",
  "bigScreen2025.250918.169": "制热平均耗电量",
  "bigScreen2025.250918.170": "制冷平均耗电量",
  "bigScreen2025.250918.171": "制热耗电量",
  "bigScreen2025.250918.172": "制冷耗电量",
  "bigScreen2025.250918.173": "机组运行时长分类统计",
  "bigScreen2025.250918.174": "制热时长",
  "bigScreen2025.250918.175": "制冷时长",
  "bigScreen2025.250918.176": "待机时长",
  "bigScreen2025.250918.177": "机组工况分析统计",
  "bigScreen2025.250918.178": "机组运行启停分布统计",
  "bigScreen2025.250918.179": "启动",
  "bigScreen2025.250918.180": "关停",
  "bigScreen2025.250918.181": "机组运行功耗分布统计",
  "bigScreen2025.250918.182": "工况分析",
  "bigScreen2025.250918.183": "能耗中心",
  "bigScreen2025.250918.184": "时间",
  "bigScreen2025.250918.185": "耗电量",
  "bigScreen2025.250918.186": "全天启动",
  "bigScreen2025.250918.187": "全天关停",
  "bigScreen2025.250918.188": "次",
  "bigScreen2025.250918.189": "光伏直驱泳池热泵",
  "bigScreen2025.250918.190": "机组能耗结构统计",
};
